import data from './data'

export default {
  data
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/select-dates/resources/index.js